import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

const customRoutes = [
  { method: "POST", path: "/send", handlerName: "send" },
];

export const announcementsService = createCrudService("announcements", customRoutes, router);
